import React, { useContext, useState, useRef } from 'react';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Menu,
  Center,
  MenuButton,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  VStack,
  Checkbox,
  CheckboxGroup,
  useDisclosure,
  chakra,
  Input,
  HStack,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { ChevronDownIcon, Search2Icon } from '@chakra-ui/icons';
import { useField } from 'formik';
import { AccountContext } from './AccountContext';
import { getAppTheme, userIsSubscriber } from './Utils/theme';

const SelectFieldMultiplo = ({ label, ...props }) => {
  const { options, placeholder, onChange, hasSelect } = props;
  const [field, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const [query, setQuery] = useState('');
  const [filteredData, setFilteredData] = useState(options);
  const colorErro = meta.error ? { colorScheme: 'red' } : {};
  let textButton = '';

  if (Array.isArray(value) && value.length > 0) {
    textButton = value
      .map((val) => {
        const option = options.find((o) => o.id === val);
        return option ? option.nome : '';
      })
      .filter(Boolean)
      .join(', ')
      .substring(0, 25);

    if (textButton.length === 25) {
      textButton += '...';
    }
  } else if (placeholder) {
    textButton = placeholder;
  } else {
    textButton = 'Selecionar';
  }

  const handleCheckboxChange = (id) => {
    const nenhumId = filteredData.find((item) => item.nome === 'Nenhum')?.id;
    const isNenhumChecked = value.includes(nenhumId);

    let newValue;

    if (id === nenhumId) {
      newValue = isNenhumChecked ? [] : [id];
    } else {
      if (value.includes(id)) {
        newValue = value.filter((i) => i !== id);
      } else {
        newValue = isNenhumChecked ? [id] : [...value, id];
      }
    }

    setValue(newValue);
  };

  const handleConfirm = () => {
    if (onChange) {
      onChange(value);
      if (props.onChange) props.onChange(value);
    }
    onClose();
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setQuery(searchValue);

    const newFilteredData = options.filter((item) => item.nome.toLowerCase().includes(searchValue.toLowerCase()));
    setFilteredData(newFilteredData);
  };

  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const initialFocusRef = useRef(null);
  return (
    <>
      <FormControl isInvalid={meta.error}>
        <FormLabel>{label}</FormLabel>
        <Menu>
          <Center>
            <MenuButton as={Button} onClick={onOpen} rightIcon={<ChevronDownIcon />} {...field} {...props} {...colorErro}>
              {textButton}
            </MenuButton>
          </Center>
        </Menu>
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      </FormControl>
      <Drawer isOpen={isOpen} finalFocusRef={btnRef} placement="bottom" autoFocus={false}>
        <DrawerOverlay />
        <DrawerContent borderRadius={20} mb="-4" width="90" minH="30vh" maxH="50vh">
          <DrawerHeader mt="5">Selecione</DrawerHeader>
          <DrawerBody>
            {hasSelect && (
              <>
                <HStack _focus={false}>
                  <InputGroup _focus={false}>
                    <Input
                      placeholder="Pesquisar"
                      focusBorderColor="teal"
                      bg={'#F0F0F0'}
                      borderRadius="8px"
                      value={query}
                      onChange={handleSearchChange}
                      _focus={false}
                    />
                    <InputRightElement width="15%" _focus={false}>
                      <Search2Icon color={'#616161'} />
                    </InputRightElement>
                  </InputGroup>
                </HStack>
              </>
            )}

            <CheckboxGroup value={value}>
              <VStack align="start" w="100" spacing={1}>
                {filteredData.map((option, index) => {
                  return (
                    <Checkbox
                      key={option.id}
                      value={option.id}
                      isChecked={value.includes(option.id)}
                      onChange={() => handleCheckboxChange(option.id)}
                      padding="1em"
                    >
                      <chakra.p fontWeight="bold" fontSize="sm">
                        {option.nome}
                      </chakra.p>
                    </Checkbox>
                  );
                })}
              </VStack>
            </CheckboxGroup>
          </DrawerBody>
          <DrawerFooter mb={'2em'}>
            <Button bg={theme.background} color="white" onClick={handleConfirm}>
              Confirmar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SelectFieldMultiplo;
